import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
	Input,
	Label,
	Form,
	FormFeedback,
	Button,
	Alert,
} from "reactstrap";
import userService from "services/UserService";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";

const ModalAlterarSenha = ({ isOpen, toggle, email }) => {
	const [loadingSubmit, setLoadingSubmit] = useState(false);

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			email: email,
			new_password: "",
			confirm_password: "",
		},
		validationSchema: Yup.object({
			new_password: Yup.string()
				.required("Por favor, informe sua nova senha"),
			confirm_password: Yup.string()
				.required("Por favor, confirme sua nova senha")
				.oneOf([Yup.ref("new_password")], "As senhas não conferem"),
		}),
		onSubmit: async (values) => {
			try {
				setLoadingSubmit(true);
				await userService.passwordChangeRequired(values);
				
				toggle();
				setLoadingSubmit(false);
				
				SendaCustomSwal.fire({
					title: "Sucesso",
					text: "Sua senha foi alterada com sucesso.",
					iconHtml: '<i class="success-icon"></i>',
					customClass: {
						confirmButton: "custom-confirm-button",
					},
				});
			} catch (error) {
				setLoadingSubmit(false);
				SendaCustomSwal.fire({
					title: "Erro",
					text: "Ocorreu um erro ao alterar a senha. Tente novamente.",
					iconHtml: '<i class="error-icon"></i>',
					customClass: {
						confirmButton: "custom-confirm-button",
					},
				});
			}
		},
	});

	return (
		<Modal isOpen={isOpen} toggle={toggle} centered>
			<ModalHeader toggle={toggle}>Alterar Senha</ModalHeader>
			<ModalBody>				
				<Form
					onSubmit={(e) => {
						e.preventDefault();
						validation.handleSubmit();
						return false;
					}}
				>
					<div className="mb-3">
						<Label className="form-label">Nova senha</Label>
						<Input
							name="new_password"
							type="password"
							placeholder="Digite a nova senha"
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.new_password || ""}
							invalid={
								validation.touched.new_password &&
								validation.errors.new_password
							}
						/>
						{validation.touched.new_password &&
						validation.errors.new_password ? (
							<FormFeedback type="invalid">
								{validation.errors.new_password}
							</FormFeedback>
						) : null}
					</div>

					<div className="mb-3">
						<Label className="form-label">Confirme a nova senha</Label>
						<Input
							name="confirm_password"
							type="password"
							placeholder="Confirme a nova senha"
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.confirm_password || ""}
							invalid={
								validation.touched.confirm_password &&
								validation.errors.confirm_password
							}
						/>
						{validation.touched.confirm_password &&
						validation.errors.confirm_password ? (
							<FormFeedback type="invalid">
								{validation.errors.confirm_password}
							</FormFeedback>
						) : null}
					</div>
					
					<div className="mt-3 d-grid">
						<Button
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
							type="submit"
							disabled={loadingSubmit}
						>
							{loadingSubmit ? (
								<span
									className="spinner-border spinner-border-sm mr-1"
									style={{
										marginRight: 10,
									}}
								></span>
							) : null}
							Alterar Senha
						</Button>
					</div>
				</Form>
			</ModalBody>
		</Modal>
	);
};

export default ModalAlterarSenha;
